import { NAME_TO_SLUG } from './workflowAppIconsData.js'

export function slugFromDisplayName(displayName) {
  const key = String(displayName || '').trim().toLowerCase()
  if (NAME_TO_SLUG[key]) return NAME_TO_SLUG[key]
  return key.replace(/\s+/g, '-')
}
